module.exports = {"659007100":"双桥镇","659007101":"石峪镇","659007102":"博河镇","659007103":"双乐镇","659007400":"双河市核心区","659007500":"兵团八十九团"}


//////////////////
// WEBPACK FOOTER
// ./src/town/659007.json
// module id = 3299
// module chunks = 0